<template>
  <div class="app-premium-page">

    <div class="row">
      <div class="col bg-white-circles pt-4 pb-5">
        <div class="text-left px-5 py-5 mx-2 mx-md-5 mt-4 rounded blue-circles">
          <h1 class="display-4 font-weight-bold text-white">Thousands of Beautiful Images and Patterns</h1>
          <p class="text-lg text-white mb-4">Perfect for developers, designers, and other creatives</p>
          <a class="btn btn-cta btn-lg px-4" :href="buyNow" target="_blank">Buy Now</a>
          <a class="btn btn-lg btn-outline-light ml-2 ml-md-4" :href="freeBundle" target="_blank">Try A Free Bundle</a> 

        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="mb-2 font-weight-bold">What You Get</h1>
          <div class="color-divider mb-4"></div>
          <ul class="list feature-list text-lg">
            <li>The entire public library</li>
            <li>All premium gradients</li>
            <li>Bonus features, like easy image download</li>
            <li>A flexible license</li>
          </ul>
        </div>
        <!-- <div class=" mx-5">
          <div class="color-divider blue-stripes"></div>
        </div> -->
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">No Subscription Needed</h1>
          <div class="color-divider mb-4"></div>
          <ul class="list feature-list text-lg">
            <li>Buy once, use forever, no account needed.</li>
            <li>Get all assets with a single download.</li>
            <li>Free updates (like new gradients) for the rest of the calendar year</li>

          </ul>
          <!-- <p class="text-lg">Buy once, use forever, no account needed.</p>
          <p class="text-lg">Get all assets with a one time download.</p>
          <p class="text-lg">Free updates (like new gradients) for the rest of the year</p> -->
        </div>
        <!-- <div class=" mx-5">
          <div class="color-divider blue-stripes"></div>
        </div> -->
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">Fast and Efficient</h1>
          <div class="color-divider mb-4"></div>
          <p class="text-lg">CSS Gradients are easy and efficient.  Show beautiful images at a fraction of the bandwidth.</p>
          <!-- <p class="text-lg">The entire download is less than 2MB.  Thats over 1700 gradients in one small file.</p> -->
          <p class="text-lg">The entire download, which includes over {{totalGrads}} gradients, is <strong>less than {{fileSize}}MB</strong>.</p>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">A Flexible License</h1>
          <div class="color-divider mb-4"></div>
          <p class="text-lg">With the standard license you can use gradients on commercial projects with no attribution.</p>
          <p class="text-lg">
            If you wan't to distribute your product (a template) or let end users customize your product with gradients, you need the
            <router-link to="/extended">extended license</router-link>.
          </p>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">Pricing &amp; Options</h1>
          <div class="color-divider mb-4"></div>
          <p class="text-lg">The complete bundle is only <strong>$49 USD</strong>.  </p>
          <p class="text-lg">You get {{totalGrads}}+ fully customizable gradients and images.  This is an <em>incredible deal</em> compared to any other graphics site.</p>
        </div>
        <div class="text-left px-4 px-sm-5 py-5-sm py-4 mx-2 mx-md-4 mt-4 rounded blue-circles">
          <a class="btn btn-lg btn-cta px-4" :href="buyNow" target="_blank">Buy Now</a>
          <a class="btn btn-lg btn-outline-light px-4 ml-2 ml-sm-4" :href="freeBundle" target="_blank">Try A Free Bundle</a>
          <a class="btn btn-lg btn-link ml-4 d-none d-lg-inline text-white" :href="allProducts" target="_blank">All Premium Bundles</a> 
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  },
  data(){
    return {
      totalGrads: 2000,
      totalCollections: 40,
      fileSize: 3,
      buyNow: 'https://gum.co/OdfQP',
      freeBundle: 'https://gum.co/amdRH',
      allProducts: 'https://gumroad.com/gradientmagic'
    }
  } 
}
</script>

<style lang="scss" scoped>

// $cta-color: #f4da70;

// .btn.btn-cta {
//   background-color: $cta-color;
//   border-color: $cta-color;
//   color: black;
//   &:hover {
//     border-color: #333;
//     color: black;
//     transition: .2s all;
//   }
// }
// .btn.btn-outline-light {
//   color: white;
// }

.app-premium-page {
  margin-bottom: -1.5rem; // Too offset the footer

  .feature-list {
    li {
      margin-bottom: .5rem;
    }
  }


}
.text-lg {
  font-size: 1.5rem;
}

.color-divider {
  height: 6px;
  width: 100%;
  background-color: #548bec;
  border-radius: 2px;
}

.blue-circles {
  background-image: radial-gradient(circle at 85% 1%, hsla(190,0%,93%,0.05) 0%, hsla(190,0%,93%,0.05) 96%,transparent 96%, transparent 100%),radial-gradient(circle at 14% 15%, hsla(190,0%,93%,0.05) 0%, hsla(190,0%,93%,0.05) 1%,transparent 1%, transparent 100%),radial-gradient(circle at 60% 90%, hsla(190,0%,93%,0.05) 0%, hsla(190,0%,93%,0.05) 20%,transparent 20%, transparent 100%),radial-gradient(circle at 79% 7%, hsla(190,0%,93%,0.05) 0%, hsla(190,0%,93%,0.05) 78%,transparent 78%, transparent 100%),radial-gradient(circle at 55% 65%, hsla(190,0%,93%,0.05) 0%, hsla(190,0%,93%,0.05) 52%,transparent 52%, transparent 100%),linear-gradient(135deg, rgb(37, 56, 222),rgb(96, 189, 244));
}

.bg-white-circles {
  background-image: radial-gradient(circle at 13% 47%, rgba(140, 140, 140,0.03) 0%, rgba(140, 140, 140,0.03) 25%,transparent 25%, transparent 100%),radial-gradient(circle at 28% 63%, rgba(143, 143, 143,0.03) 0%, rgba(143, 143, 143,0.03) 16%,transparent 16%, transparent 100%),radial-gradient(circle at 81% 56%, rgba(65, 65, 65,0.03) 0%, rgba(65, 65, 65,0.03) 12%,transparent 12%, transparent 100%),radial-gradient(circle at 26% 48%, rgba(60, 60, 60,0.03) 0%, rgba(60, 60, 60,0.03) 6%,transparent 6%, transparent 100%),radial-gradient(circle at 97% 17%, rgba(150, 150, 150,0.03) 0%, rgba(150, 150, 150,0.03) 56%,transparent 56%, transparent 100%),radial-gradient(circle at 50% 100%, rgba(25, 25, 25,0.03) 0%, rgba(25, 25, 25,0.03) 36%,transparent 36%, transparent 100%),radial-gradient(circle at 55% 52%, rgba(69, 69, 69,0.03) 0%, rgba(69, 69, 69,0.03) 6%,transparent 6%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
}
</style>